<template>
  <div class="building_container">
    <!-- 경고 팝업 -->
    <PopUpModal v-if="isPopUpModal" :text="popupModalText" @close-modal="onCloseModal" />
    <PopUpModal v-if="isPopUpModalError" :text="popupModalText" @close-modal="isPopUpModalError = false" />
    <!-- 큐레이션 미리 보기 -->
    <CurationInfo v-if="showCurationInfo" :curationInfo="curationInfo" @closeCurationInfo="showCurationInfo = false" />
    <!-- 임시저장 완료 모달 -->
    <CancelModal v-if="cancelStatus" />
    <!-- 중간 저장 -->
    <CommonConfirm
      v-if="cancelCheckStatus"
      :confirmid="'cancelcheckmodal'"
      @close-modal="onCancelCheckStatusConfirmNo"
      @confirm-modal="onCancelCheckStatusConfirmYes"
    >
      <template #contents>
        <div class="stopmodal_body">
          <h3 class="stopmodal_text1">
            등록중인 스페이스를 저장할까요?
          </h3>
        </div>
      </template>
    </CommonConfirm>
    <!-- 스페이스 등록 템플릿 -->
    <SpaceManageSlot :progress="48" :closefn="backPage">
      <template #pagename>
        스페이스 등록
      </template>

      <template #spacestatus>
        주로 방문하는 고객층은 누구신가요?
      </template>

      <template #spacebody>
        <ul class="spaceinsert_target_container">
          <li class="spaceinsert_target_item" v-for="item in targetList" :key="'target' + item.key">
            <a tabindex="0" class="cursor" @keyup.enter="onClickTarget(item)" @click="onClickTarget(item)">
              <div class="target_hover" :class="{ active: targetNo.includes(item.key) }">
                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8582 1.98515C15.8783 -0.75307 20.5453 -0.662185 23.4549 2.28118C26.3631 5.22584 26.4634 9.91548 23.7583 12.9744L12.8556 24L1.95554 12.9744C-0.74955 9.91548 -0.64798 5.21805 2.25897 2.28118C5.17105 -0.65829 9.82911 -0.756965 12.8582 1.98515Z"
                    fill="white"
                  />
                </svg>
              </div>
              <img class="target_img" :src="item.imgurl" :alt="item.text" />
              <span class="target_text">{{ item.text }}</span>
            </a>
          </li>
        </ul>
      </template>
    </SpaceManageSlot>
    <!-- Footer -->
    <BuildingManageFooter :rightbtndisabled="rightBtnDisabled" :leftbtnfn="onClickPre" :rightbtnfn="updateCuration">
      <template #footerleft>
        <PreViewSelectCuration
          :color="color"
          :selectkey="['color', 'material']"
          :material="bottomMaterialList"
          @click-detailmodal="onClickDetailModal"
        />
      </template>
    </BuildingManageFooter>
  </div>
</template>
<script>
import CancelModal from '@/components/modal/Space/CancelModal.vue';
import CommonConfirm from '@/components/common/CommonConfirm.vue';
import {
  checkSubscribe,
  getCurationInfoApi,
  updateConfirmCuration,
  updateCurationAllTemp
} from '@/service/api/profileApi';
import SpaceManageSlot from '@/slot/SpaceManageSlot.vue';
import BuildingManageFooter from '@/components/Building/BuildingManageFooter.vue';
import PreViewSelectCuration from '@/components/Building/PreViewSelectCuration.vue';
import CurationInfo from '@/components/modal/Space/CurationInfo.vue';
import PopUpModal from '@/components/modal/common/PopUpModal.vue';
export default {
  props: {
    updatecurationinfo: {
      type: Function,
      required: false,
      default: null
    },
    linkmyspace: {
      type: Function,
      required: false,
      default: null
    }
  },
  components: {
    SpaceManageSlot,
    CommonConfirm,
    CancelModal,
    BuildingManageFooter,
    PreViewSelectCuration,
    CurationInfo,
    PopUpModal
  },
  data() {
    return {
      btnLoading: false,
      selectSpaceId: localStorage.getItem('spaceId'),
      color: null,
      targetNo: [],
      targetList: [
        { key: 1, text: '유아/아동', imgurl: 'media/img/unsplash_XIFuymJydII.png' },
        { key: 2, text: '청소년', imgurl: 'media/img/image 1715.png' },
        { key: 3, text: '청년', imgurl: 'media/img/unsplash_yk-CgvlrK1g.png' },
        { key: 4, text: '중장년', imgurl: 'media/img/unsplash_6anudmpILw4.png' },
        { key: 5, text: '노년', imgurl: 'media/img/unsplash_yRmmm3t1oX8.png' }
      ],
      bottomMaterialList: [],
      curationInfo: null,
      showCurationInfo: false,
      cancelStatus: false,
      cancelCheckStatus: false,
      popupModalText: '',
      isPopUpModal: false,
      isPopUpModalError: false
    };
  },
  created() {
    this.getCurationInfo();
  },
  methods: {
    onDeleteSpace(msg) {
      this.isPopUpModal = true;
      this.popupModalText = msg;
    },
    onCloseModal() {
      this.isPopUpModal = false;
      this.$router.push({ name: 'MySpace' });
    },
    onCancelCheckStatusConfirmNo() {
      this.linkmyspace(this.selectSpaceId);
    },
    async onCancelCheckStatusConfirmYes() {
      const { targetUnit } = this.onFilterCurationInfo();
      const { isSuccess, msg } = await this.updatecurationinfo({
        spaceId: this.selectSpaceId,
        target: this.targetNo
          .sort((a, b) => {
            return a - b;
          })
          .toString(),
        targetUnit
      });
      if (isSuccess) {
        this.cancelCheckStatus = false;
        this.cancelStatus = true;
      } else {
        this.onDeleteSpace(msg);
      }
    },
    onClickDetailModal() {
      this.showCurationInfo = true;
    },
    onClickPre() {
      this.$router.push({ name: 'SpaceInsertStoreMaterialV2' });
    },
    onFilterCurationInfo() {
      let array = [];
      this.targetNo.forEach(val => {
        const item = this.$store.getters['player/getTargetUnitFilter'](val);
        array = [...array, ...item];
      });
      const set = new Set(array);
      const targetUnit = Array.from(set).join(',');
      return {
        targetUnit
      };
    },
    async updateCuration() {
      const { targetUnit } = this.onFilterCurationInfo();
      try {
        const { data } = await updateCurationAllTemp({
          spaceId: this.selectSpaceId,
          target: this.targetNo
            .sort((a, b) => {
              return a - b;
            })
            .toString(),
          targetUnit
        });
        const { resultCd } = data;
        if (resultCd === '0000') {
          const { data: confirmCurationData } = await updateConfirmCuration(
            this.selectSpaceId,
            this.curationInfo.curationId
          );

          const { resultCd: confirmCurationResultCd } = confirmCurationData;

          if (confirmCurationResultCd === '0000') {
            this.$router.push({ name: 'SpaceInsertStoreCountryV2' });
          } else {
            throw Error('타겟 정보 저장 실패 : ' + confirmCurationResultCd);
          }
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log('타겟 정보 저장 실패 : ' + error);
      }
    },
    async getCurationInfo() {
      try {
        const { data } = await getCurationInfoApi(this.selectSpaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { target, color, material } = result;
          this.curationInfo = result;
          this.color = color;
          this.bottomMaterialList = material;
          if (target) {
            this.targetNo = this.$store.getters['curation/getTargetValuesByKoText'](target);
          }
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log('큐레이션 정보 조회 : ' + error);
      }
    },
    backPage() {
      checkSubscribe(this.selectSpaceId).then(res => {
        const { resultCd, result } = res.data;
        if (resultCd === '0000') {
          if (result === 'S') {
            this.cancelCheckStatus = true;
          } else {
            this.$router.push({ name: 'buildingBridge' }).catch(() => {});
          }
        }
      });
    },
    onClickTarget(item) {
      const { key } = item;
      const findIdx = this.targetNo.findIndex(findItem => findItem === key);
      if (findIdx > -1) {
        this.targetNo.splice(findIdx, 1);
      } else {
        this.targetNo.push(key);
      }
    }
  },
  computed: {
    rightBtnDisabled() {
      if (this.targetNo.length > 0) {
        return false || this.btnLoading;
      }
      return true;
    }
  }
};
</script>
<style scoped src="@/assets/css/building/spaceinserttarget.css"></style>
